<div class="card bg-base-100 shadow-sm">
  <figure class="page-img-container">
   	<img hSkeleton="200px" [src]="binderS.getImgPage(page(), scan())" [attr.loading]="lazy()"/>
		@if(!isFinish()){
			<div class="progress-component">
				<lgb-progress></lgb-progress>
			</div>
		}
		@else if(canFull() && admin()){
			<div class="fav-icon">
				<a (click)="toggleFavoritePage()" class="add-fav glass rounded-full bg-black/40 mb-3">
					<i [ngClass]="{'fa-solid': page()?.isFavorite, 'fa-light': !page()?.isFavorite}" class="fa-light fa-bookmark"></i>
				</a>
			</div>
		}
  </figure>
	@if(isFinish()){
	  <div class="card-body">
	    <div class="card-actions">
	    	@if(canFull()){
		   		<a (click)="fullScreen.emit(true)" class="btn text-primary">
		   			<i class="fa-light fa-expand"></i>
			    </a>
				}
				@if(admin()){
					<lgb-share [element]="page()" typeElement="page">
			   		<span class="btn text-primary mx-1">
			   			<i class="fa-light fa-paper-plane"></i>
				    </span>
				  </lgb-share>
				}
				@if(!canFull() && admin()){
					<a (click)="toggleFavoritePage()" class="btn text-primary">
						<i [ngClass]="{'fa-solid': page()?.isFavorite, 'fa-light': !page()?.isFavorite}" class="fa-light fa-bookmark"></i>
					</a>
				}
				@if(admin()){
			    <div class="add-btn-container ml-1">
						<button (click)="scanService.enable('page', page().ident)" class="btn btn-primary btn-gradient litle-btn-gradient">
							<i class="add-item fa-regular fa-plus-large"></i>
						</button>
					</div>
				}
	    </div>
	  </div>
	}
</div>